export enum ProcessingStatus {
  PENDING = 'Pending',
  PROCESSING = 'Processing',
  INVALID = 'Invalid',
  FAILED = 'Failed',
  SUCCEEDED = 'Succeeded',
}
